import CurrencyFormat from "@ui-kit/data-display/CurrencyFormat/CurrencyFormat.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Icon from "@ui-kit/icons/Icon.web";
import { enums } from "@shared/constants";
import { CartTotalProps } from "./CartTotal.props";
import { usePublicBasket } from "../../services/usePublicBasket";

const CartTotal = ({ venue, includeTotal = true }: CartTotalProps) => {
  const {
    currency: basketCurrency,
    totalItemQuantity,
    totalPrice,
  } = usePublicBasket();

  const currency =
    basketCurrency || venue?.currency || enums.CURRENCY_MAP.CAD.key;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      fontWeight="bold"
      color="primary.800"
    >
      <Flex>
        <Icon.Cart.Outline boxSize="element.xl" mr="2xs" />
        {totalItemQuantity}
      </Flex>
      {includeTotal && (
        <Flex>
          <Text>
            <CurrencyFormat
              value={totalPrice}
              currency={currency}
              displayType="text"
            />
            {` ${currency}`}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};

export default CartTotal;
